module.exports = __webpack_public_path__ + "static/media/Logo-09.6b29511b.jpg";